import api from 'api';

import { defaultPagination } from './general';

type GetTrainingsType = {id: number | string}

export const listTrainings = async (params) => api().get('/trainings', { params: { ...defaultPagination, ...params } });

export const getTrainings = async ({ id }:GetTrainingsType) => api().get(`/trainings/${id}`);

export const getUserTrainings = async ({ id }:GetTrainingsType) => api().get(`/users/trainings/${id}`);

export const createTrainings = async ({ data }) => api().post('/trainings', data);

export const updateTrainings = async ({ id, data }) => api().put(`/trainings/${id}`, data);

export const reviewTraining = async ({ id, userId, data }) => api().put(`/trainings/${id}/${userId}`, data);

export const unassignTraining = async ({ id, userId }) => api().delete(`/trainings/${id}/${userId}`);

export const assignTrainings = async ({ data }) => {
  const id = window.location.pathname?.split('/')?.[2];

  return api().post(`/trainings/assign/${id}`, data);
};
